<template>
    <div class="card mt-2 mb-2 ms-5 me-5">
        <div class="card-body">
            <h4>
                <strong>Datos de cotización </strong>
            </h4>
            <div class="table-responsive">
                <table class="mx-auto">
                    <tbody>
                        <tr>
                            <td class="lblform"><strong> Peso del material por unidad:
                                    <br> <i>(Kilogramos)</i> </strong></td>
                            <td class="inputForm">
                                <input id="unitWeight" type="number" readonly class="form-control"
                                    v-model="weightByUnit" />
                            </td>
                            <td class="lblform">
                                <strong> Total servicios por unidad: </strong>
                            </td>
                            <td class="inputForm">
                                <input type="number" id="unitServices" readonly class="form-control"
                                    v-model="priceServicesByUnit" />
                            </td>
                        </tr>
                        <tr>
                            <td class="lblform">
                                <strong>Peso total del material:
                                    <br> <i>(Kilogramos)</i>
                                </strong>
                            </td>
                            <td class="inputForm">
                                <input type="number" id="totalWweight" readonly class="form-control"
                                    v-model="totalWeight" />
                            </td>
                            <td class="lblform"><strong>Precio por unidad: </strong></td>
                            <td class="inputForm">
                                <input type="text" id="unitPrice" readonly class="form-control" v-model="unitPrice" />
                            </td>
                        </tr>
                        <tr>
                            <td class="lblform"><strong>Cantidad de piezas:</strong></td>
                            <td class="inputForm">
                                <input id="amount" type="number" min="1" placeholder="1"
                                    class="form-control avilable-input" v-model="quantity" @change="changeQuantity" />
                            </td>
                            <td class="lblform">
                                <strong>Precio total: <br> <i>(IVA incluido)</i></strong>
                            </td>
                            <td class="inputForm">
                                <input type="text" id="totalPrice" readonly class="form-control" v-model="finalPrice" />
                            </td>
                            <td class="lblform">
                                <strong>Precio con descuento: </strong>
                            </td>
                            <td class="inputForm">
                                <input type="text" id="descountPrice" readonly class="form-control"
                                    v-model="discountPrice" />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"></td>
                            <td colspan="2">
                                <button class="btn btn-danger">Añadir Cotización</button>
                            </td>
                            <td colspan="2">
                                <button class="btn btn-danger" @click.prevent="goBack()"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                                    </svg> Grupo de formas </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        getKiloPrice: Number,
        getWeigthMeter: Number,
        getLengthValue: Number,
        getTotalSevices: Number,
    },
    watch: {
        getLengthValue(newVal) {
            if (newVal !== null) {
                // console.log("Longitud final:" + this.getLengthValue);
                this.calculateRawMaterialPrice();
                this.calculateWeight();
            }
        },
        getKiloPrice(newVal) {
            if (newVal !== null) {
                // console.log("Kilo precio profilePriceCom:" + this.getKiloPrice);
                this.calculateRawMaterialPrice();
            }
        },
        getWeigthMeter(newVal) {
            if (newVal !== null) {
                this.calculateWeight();
            }
        },
        getTotalSevices(newVal) {
            if (newVal !== null) {
                // console.log("Total servicios por unidad:" + this.getTotalSevices);
                this.priceServicesByUnit = this.getTotalSevices;
                this.calculateRawMaterialPrice()
            }
        }
    },
    data() {
        return {
            weightByUnit: 0,
            totalWeight: 0,
            priceServicesByUnit: 0,
            quantity: 1,
            //Valor de materia prima (Con IVA e utilidad)
            unitPrice: 0,
            //Valor final del producto incluido los servicios
            finalPrice: 0,
            //Valor final del producto con descuento
            discountPrice: 0,
            //Constantes
            constants: [],
            // Variable goblal para el precio en bruto
            grossRawMatPrice: 0,
            //Variable adiconal para almacenar el precio unitario con descuento.
            discountByUnit: 0,
        };
    },
    methods: {
        changeQuantity() {
            //console.log(this.weightByUnit);
            //console.log(this.quantity);
            //console.log(this.discountByUnit);
            this.totalWeight = this.quantity * this.weightByUnit;
            this.finalPrice = this.roundAndFormatPrice(this.quantity * parseFloat(this.unitPrice.replace(/\./g, '').replace(',', '.')));
            this.discountPrice = this.roundAndFormatPrice(this.quantity * parseFloat(this.discountByUnit.replace(/\./g, '').replace(',', '.')));
        },
        calculateRawMaterialPrice() {
            // Convertir TODOS los porcentajes a factores de multiplicación
            let ivaFactor = 1 + (this.constants[0].value / 100);       // IVA: +% (ej: 19% → 1.19)
            let utilityFactor = 1 + (this.constants[1].value / 100);   // Utilidad: +% (ej: 30% → 1.30)
            let discountFactor = 1 - (this.constants[2].value / 100);  // Descuento: -% (ej: 10% → 0.90)
            let incrementFactor = 1 + (this.constants[3].value / 100); // Incremento: +% (ej: 15% → 1.15)


            // --- Calculo del precio bruto de la materia prima
            // --- Area
            let rawMatArea = (this.getLengthValue / 100);
            //console.log(rawMatArea);

            this.grossRawMatPrice = rawMatArea * this.getWeigthMeter * this.getKiloPrice;
            //console.log(this.grossRawMatPrice);


            // FLUJO DE CÁLCULO EN CADENA (todos multiplicadores):
            // 1. PRECIO BASE → × INCREMENTO → × IVA → × UTILIDAD → + SERVICIOS → × DESCUENTO

            let finalPriceBeforeDiscount = this.grossRawMatPrice
                * incrementFactor    // Aplicar incremento porcentual
                * ivaFactor          // Aplicar IVA
                * utilityFactor      // Aplicar margen de utilidad (ganancia)
                + this.priceServicesByUnit; // Sumar servicios (valor fijo)

            // Aplicar descuento al final
            let discountPrice = finalPriceBeforeDiscount * discountFactor;

            //--- Aplicar formato y redondear
            let rawMatPriceFormattedAndRound = this.roundAndFormatPrice(finalPriceBeforeDiscount);
            let rawMatDiscountPriceFormattedAndRound = this.roundAndFormatPrice(discountPrice);

            // //console.log(rawMatPriceFormattedAndRound);

            // //Asignar valores a los campos precioUnitario, precioFinal y precioDescuento
            this.unitPrice = rawMatPriceFormattedAndRound;
            this.finalPrice = this.unitPrice;
            this.discountPrice = rawMatDiscountPriceFormattedAndRound;
            this.discountByUnit = this.discountPrice;
        },
        roundAndFormatPrice(num) {
            const roundedNum = Math.ceil(num / 1000) * 1000;
            const formattedNum = roundedNum.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return formattedNum;
        },
        recalculateValues() {
            this.quantity = 1;
            this.totalWeight = this.getWeightUnit;
            this.calculateRawMaterialPrice();
        },
        async getConstants() {
            try {
                let res = await axios.get(RUTA_SERVIDOR + "api/variable/list", {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                // console.log(res.data);
                if (!res.data) {
                    console.log("There has been a different error with the data.");
                } else {
                    //console.log(res.data);
                    this.constants = res.data;
                    //console.log(this.constants);
                }
            } catch (err) {
                console.log(`There has been an error ${err}`);
            }
        },
        goBack() {
            this.$router.push("/FamilyForms");
        },
        roundWeight(numero) {
            return Math.round(numero * 10) / 10;
        },
        calculateWeight() {
            this.weightByUnit = this.roundWeight(this.getWeigthMeter * (this.getLengthValue / 100));
            this.totalWeight = this.roundWeight(this.weightByUnit * this.quantity);
        },
    },
    mounted() {
        this.getConstants();
    }
}
</script>
<style scoped>
.card {
    border: solid 2px #a6323b;
}

input [type="number"] {
    padding: 2px 6px 2px 16px;
    border: solid 5px #999999;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
}

.avilable-input {
    background-color: #FCE196;
}
</style>